<template>
  <div>
    <SiteHero
      image="/media/import-hero.webp"
      eyebrow="Portal aukcyjny"
      title="Import"
      lead="Jako importer z wieloletnim stażem doskonale panujemy nad logistyką i mamy pełną kontrolę nad każdym etapem sprowadzenia pojazdu."
      scroll-to="krok-po-kroku"
    />

    <section id="krok-po-kroku" class="site_section">
      <div class="site_container">
        <p class="site_eyebrow"><mark>01</mark> Krok po kroku</p>
        <h2 class="steps_heading">Sprowadzenie pojazdu z Japonii od A do Z</h2>

        <SiteSteps v-reveal :steps="steps" />
      </div>
    </section>

    <section class="site_container auctions_wrap">
      <div class="auctions">
        <p class="site_eyebrow site_eyebrow--accent"><mark>02</mark> Aukcje Japonia Cars</p>
        <h2>Zainteresowała Cię nasza oferta aukcyjna? Dowiedz się więcej!</h2>
        <router-link to="/aukcje/" class="site_button">Sprowadź dostepne aukcje <ArrowIcon /></router-link>
      </div>
    </section>

    <section class="site_section">
      <div class="site_container">
        <div class="stock_header">
          <div>
            <p class="site_eyebrow"><mark>03</mark> Aktualna oferta</p>
            <h2>Auta dostępne od zaraz.</h2>
            <p class="stock_lead">
              Pojazdy sprowadzone, po inspekcji technicznej, z pełną dokumentacją.
            </p>
          </div>
          <router-link to="/samochody/" class="site_button site_button--outline">Zobacz wszystkie auta</router-link>
        </div>

        <ul class="stock_grid">
          <li v-for="car in cars" :key="car.slug" v-reveal>
            <CarCard :car="car" />
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>

<script>
import pageHead from '@/mixins/pageHead'
import { pageSchema } from '@/utils/schema'
import cars from '@/data/cars'
import SiteHero from '@/components/SiteHero.vue'
import SiteSteps from '@/components/SiteSteps.vue'
import CarCard from '@/components/CarCard.vue'
import ArrowIcon from '@/components/icons/ArrowIcon.vue'

export default {
  name: 'ImportPage',
  components: { SiteHero, SiteSteps, CarCard, ArrowIcon },
  mixins: [pageHead],

  pageHead: {
    title: 'Import - Japonia Cars',
    description:
      'Import samochodów z Japonii krok po kroku: wycena, inspekcja, transport morski i odbiór pojazdu.',
    schema: pageSchema({
      path: '/import/',
      name: 'Import',
      breadcrumbs: [{ name: 'Import' }],
      published: '2026-05-12T05:53:19+00:00',
      modified: '2026-06-08T11:58:13+00:00',
    }),
  },

  data() {
    return {
      cars,
      steps: [
        {
          title: 'Wycena kosztów',
          text: 'Cenę Twojego przyszłego auta oszacujemy jeszcze przed złożeniem oferty.',
        },
        {
          title: 'Wybór auta i inspekcja',
          text:
            'Po wskazaniu interesującego Cię egzemplarza zlecamy niezależną inspekcję techniczną, ' +
            'którą powtarzamy także po wygranej aukcji. Ważne: Jeżeli ujawnią się uszkodzenia ' +
            'nieuwzględnione w raporcie, możesz zrezygnować z odbioru bez konsekwencji.',
        },
        {
          title: 'Transport i formalności',
          text:
            'Następnie organizujemy transport morski, odprawę celną, wyliczenie cła i akcyzy, ' +
            'tłumaczenie japońskich dokumentów oraz rejestrację.',
        },
        {
          title: 'Odbiór pojazdu',
          text:
            'Auto dostarczamy pod wskazany adres. Czas realizacji od licytacji do odbioru kluczyków ' +
            'w Polsce wynosi około trzech miesięcy (choć wiele zależy od rodzaju zlecenia).',
        },
      ],
    }
  },
}
</script>

<style scoped>
.steps_heading {
  margin: 15px 0 48px;
}

mark {
  background: none;
  color: var(--accent);
}

/* --------------------------------------------------------- auctions --- */

.auctions_wrap {
  padding-bottom: 80px;
}

.auctions {
  padding: 64px 32px;
  border-radius: var(--radius);
  background: var(--ink);
  color: var(--ink-invert);
  text-align: center;
}

.auctions .site_eyebrow {
  justify-content: center;
}

.auctions h2 {
  max-width: 792px;
  margin: 15px auto 24px;
  color: var(--ink-invert);
  font-size: 36px;
}

/* ------------------------------------------------------------ stock --- */

.stock_header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 32px;
  margin-bottom: 48px;
}

.stock_header h2 {
  margin: 15px 0 17px;
}

.stock_lead {
  max-width: 543px;
}

.stock_grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

@media (max-width: 1024px) {
  .stock_grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 767px) {
  .stock_header {
    flex-direction: column;
    align-items: flex-start;
  }

  .stock_grid {
    grid-template-columns: 1fr;
  }

  .auctions {
    padding: 40px 20px;
  }
}
</style>
